// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@tps/App/SharedStyles/CartLineSharedStyles";
import { orderLinesListStyles } from "@tps/Overrides/Components/OrderLinesList";
import { mergeWithCss, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

orderLinesListStyles.productImageLink = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.orderLineCardImage = {
    height: "80px",
    width: "80px",
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.priceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

orderLinesListStyles.lableText = {
    ...mergeWithCss(cartLineSharedStyles.qtyLabel, {
        css: css`
            ${xScreen("gt", "md")} {
                display: block;
            }
        `,
    }),
};

orderLinesListStyles.readOnlyNotesText = {
    wrapper: {
        css: css`
            margin-top: 5px;
        `,
    },
};

orderLinesListStyles.qtyOrderedField = {
    readOnlyQuantityText: {
        ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText, {
            extendedStyles: {
                heading: {
                    css: css`
                        ${xScreen("gt", "md")} {
                            display: block;
                        }
                    `,
                },
                wrapper: {
                    css: css`
                        margin-bottom: 12px;
                    `,
                },
            },
        }),
    },
};

orderLinesListStyles.qtyShippedField = {
    readOnlyQuantityText: {
        ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText, {
            extendedStyles: {
                heading: {
                    css: css`
                        ${xScreen("gt", "md")} {
                            display: block;
                        }
                    `,
                },
            },
        }),
    },
};

orderLinesListStyles.productInfoSectionOptionsGridItem = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productInfoSectionOptionsLableText = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

orderLinesListStyles.productInfoSectionOptionsValueText = {
    ...cartLineSharedStyles.configurationOptionText,
};

orderLinesListStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

orderLinesListStyles.orderLineInfoPromotionText = {
    ...cartLineSharedStyles.promotionNameText,
};

orderLinesListStyles.promotionsContainer = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productQtyContainer = {
    css: css`
        @media print {
            display: table;
            content: "";
            clear: both;
            width: 100%;
            max-width: 250px;
            > div:first-child {
                float: left;
                padding-right: 40px;
            }
        }
    `,
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.priceWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            margin-bottom: 12px;
        }
    `,
};

orderLinesListStyles.attributesWrapper = {
    ...cartLineSharedStyles.attributesWrapper,
};

orderLinesListStyles.variantDisplay = {
    ...cartLineSharedStyles.variantDisplay,
};
